/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the EmailAddressComponent interface.
 */
export function instanceOfEmailAddressComponent(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    return true;
}
export function EmailAddressComponentFromJSON(json) {
    return EmailAddressComponentFromJSONTyped(json, false);
}
export function EmailAddressComponentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'address': json['address'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
    };
}
export function EmailAddressComponentToJSON(json) {
    return EmailAddressComponentToJSONTyped(json, false);
}
export function EmailAddressComponentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'address': value['address'],
        'displayName': value['displayName'],
    };
}
